export const CERTIFICATION_LIST = [
  { id: 'toss', name: '토스', icon: '/assets/pngs/ok/toss.png' },
  {
    id: 'kakaobank',
    name: '카카오뱅크',
    icon: '/assets/pngs/ok/kakaobank.png',
  },
  {
    id: 'banksalad',
    name: '뱅크샐러드',
    icon: '/assets/pngs/ok/banksalad.png',
  },
  {
    id: 'signgate',
    name: '삼성패스',
    icon: '/assets/pngs/ok/signgate.png',
  },
  { id: 'dreamsign', name: '드림인증', icon: '/assets/pngs/ok/dreamsign.png' },
  { id: 'kbstar', name: '국민인증서', icon: '/assets/pngs/ok/kbstar.png' },
  { id: 'shinhan', name: '신한인증서', icon: '/assets/pngs/ok/shinhan.png' },
  { id: 'kebhana', name: '하나인증서', icon: '/assets/pngs/ok/kebhana.png' },
  {
    id: 'mobile-ok',
    name: '휴대폰 본인인증',
    icon: '/assets/pngs/ok/mobile-ok.png',
  },
] as const;

/** //* 통신사 */
export enum MOBILE_AGENCY_TYPE {
  SKT = 'SK',
  KT = 'KT',
  LG = 'LG',
  /** //* 알뜰폰 */
  SKT_THRIFTY = 'SM',
  KT_THRIFTY = 'KM',
  LG_THRIFTY = 'LM',
}

export const MOBILE_AGENCY_TYPE_NAME_MAP = {
  [MOBILE_AGENCY_TYPE.SKT]: 'SKT',
  [MOBILE_AGENCY_TYPE.KT]: 'KT',
  [MOBILE_AGENCY_TYPE.LG]: 'LG',
  [MOBILE_AGENCY_TYPE.SKT_THRIFTY]: 'SKT 알뜰폰',
  [MOBILE_AGENCY_TYPE.KT_THRIFTY]: 'KT 알뜰폰',
  [MOBILE_AGENCY_TYPE.LG_THRIFTY]: 'LG U+ 알뜰폰',
};

export const MOBILE_AGENCY_LIST = [
  {
    type: MOBILE_AGENCY_TYPE.SKT,
    imageUrl: '/assets/pngs/dlp/seoul/skt-logo.png',
    name: 'SKT',
  },
  {
    type: MOBILE_AGENCY_TYPE.KT,
    imageUrl: '/assets/pngs/dlp/seoul/kt-logo.png',
    name: 'KT',
  },
  {
    type: MOBILE_AGENCY_TYPE.LG,
    imageUrl: '/assets/pngs/dlp/seoul/lg-logo.png',
    name: 'LG U+',
  },
  {
    type: MOBILE_AGENCY_TYPE.SKT_THRIFTY,
    parentName: 'SKT',
    name: '알뜰폰',
  },
  {
    type: MOBILE_AGENCY_TYPE.KT_THRIFTY,
    parentName: 'KT',
    name: '알뜰폰',
  },
  {
    type: MOBILE_AGENCY_TYPE.LG_THRIFTY,
    parentName: 'LG U+',
    name: '알뜰폰',
  },
];
